(function () {
  'use strict';
  /* Untracked products report a stock of 0, which made the theme lock the quantity box at 0. Lift that limit before the theme scripts run. */
  Array.prototype.forEach.call(document.querySelectorAll('input.js_qty[data-max="0"], input.js_qty[data-max=""]'), function (q) {
    q.setAttribute('data-max', '9999');
    if (!(parseInt(q.value, 10) > 0)) q.value = q.getAttribute('data-min') || '1';
  });
  if (!document.querySelector('.pr')) return;
  var root = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  var header = root.querySelector('[data-pr-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  $$('[data-pr-mega]').forEach(function (btn) {
    var wrap = btn.parentElement;
    btn.addEventListener('click', function () {
      var open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) { wrap.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); } });
  });

  var drawer = root.querySelector('[data-pr-drawer]');
  var lastFocus = null;
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { lastFocus = document.activeElement; var f = drawer.querySelector('.pr-drawer__head button'); if (f) f.focus(); }
    else if (lastFocus) { lastFocus.focus(); }
  }
  $$('[data-pr-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-pr-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setDrawer(false); $$('.pr-mega.is-open').forEach(function (m) { m.classList.remove('is-open'); }); } });

  $$('[data-pr-focus-search]').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = root.querySelector('#pr-q');
      if (!i) return;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { i.focus(); }, 380);
    });
  });

  /* hero slider */
  var stage = root.querySelector('[data-pr-hero]');
  if (stage) {
    var hero = stage.parentElement;
    var slides = $$('.pr-slide', stage);
    var dots = $$('.pr-hero__dots button', stage);
    var idx = 0, timer = null, dur = 6500;
    hero.style.setProperty('--pr-dur', dur + 'ms');
    var go = function (n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === idx;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a', s).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
        if (on) { $$('img[loading=lazy]', s).forEach(function (im) { im.loading = 'eager'; }); }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); d.setAttribute('aria-pressed', i === idx); });
    };
    var play = function () { if (reduce || slides.length < 2) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, dur); };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); play(); }); });
    hero.addEventListener('mouseenter', function () { clearInterval(timer); hero.classList.add('is-paused'); });
    hero.addEventListener('mouseleave', function () { hero.classList.remove('is-paused'); play(); });
    hero.addEventListener('focusin', function () { clearInterval(timer); hero.classList.add('is-paused'); });
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) { go(idx + (dx < 0 ? 1 : -1)); play(); } sx = null;
    });
    go(0); play();
  }

  /* hero product slideshow */
  $$('[data-pr-feat]').forEach(function (feat) {
    var slides = $$('.pr-fslide', feat), thumbs = $$('.pr-feat__thumbs button', feat);
    if (slides.length < 2) return;
    var i = 0, ft = null;
    var show = function (n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
        if (on) { $$('img[loading=lazy]', s).forEach(function (im) { im.loading = 'eager'; }); }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-pressed', k === i); });
      var th = thumbs[i]; if (th && th.parentElement) { th.parentElement.scrollTo({ left: th.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' }); }
    };
    var auto = function () { if (reduce) return; clearInterval(ft); ft = setInterval(function () { show(i + 1); }, 7000); };
    var p = feat.querySelector('[data-pr-feat-prev]'), nx = feat.querySelector('[data-pr-feat-next]');
    if (p) p.addEventListener('click', function () { show(i - 1); auto(); });
    if (nx) nx.addEventListener('click', function () { show(i + 1); auto(); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); auto(); }); });
    feat.addEventListener('mouseenter', function () { clearInterval(ft); });
    feat.addEventListener('mouseleave', auto);
    feat.addEventListener('focusin', function () { clearInterval(ft); });
    var fx = null, fstage = feat.querySelector('.pr-feat__stage');
    fstage.addEventListener('touchstart', function (e) { fx = e.touches[0].clientX; }, { passive: true });
    fstage.addEventListener('touchend', function (e) { if (fx === null) return; var dx = e.changedTouches[0].clientX - fx; if (Math.abs(dx) > 50) { show(i + (dx < 0 ? 1 : -1)); auto(); } fx = null; });
    show(0); auto();
  });

  $$('[data-pr-rail]').forEach(function (rail) {
    var track = rail.querySelector('.pr-rail__track');
    var prev = rail.querySelector('[data-pr-prev]'), next = rail.querySelector('[data-pr-next]');
    var upd = function () {
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    };
    var step = function (dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  });

  $$('[data-pr-tabs]').forEach(function (wrap) {
    var tabs = $$('[role=tab]', wrap);
    var select = function (t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1;
        var pn = document.getElementById(x.getAttribute('aria-controls'));
        if (pn) pn.hidden = !on;
      });
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (n === null) return; e.preventDefault();
        var nt = tabs[(n + tabs.length) % tabs.length]; select(nt); nt.focus();
      });
    });
  });

  $$('[data-pr-more]').forEach(function (b) {
    var box = document.getElementById(b.getAttribute('aria-controls'));
    b.addEventListener('click', function () {
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
      b.textContent = open ? 'Show less' : 'Read more';
    });
  });

  var toast = root.querySelector('[data-pr-toast]'), tt = null;
  function showToast(title, img) {
    if (!toast) return;
    toast.querySelector('b').textContent = title || 'Item';
    var im = toast.querySelector('img');
    if (img) { im.src = img; im.hidden = false; } else { im.hidden = true; }
    toast.classList.add('is-on'); clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }
  function setCount(n) { $$('[data-pr-count]').forEach(function (c) { c.textContent = n; }); }
  /* keep header cart count in sync when other theme scripts add to cart */
  var syncCount = function () { if (window.fetch) fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); };
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function (u) { var p = _f.apply(this, arguments); try { var url = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(url)) { p.then(function () { setTimeout(syncCount, 150); }); } } catch (e) {} return p; };
  }
  if (window.jQuery) { window.jQuery(document).ajaxComplete(function (e, x, o) { if (o && /\/cart\/(add|change|update|clear)/.test(o.url || '')) syncCount(); }); }
  $$('[data-pr-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button'), label = btn.querySelector('span');
      var card = form.closest('.pr-card, .pr-fslide');
      btn.classList.add('is-busy');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          setCount(cart.item_count);
          btn.classList.remove('is-busy'); btn.classList.add('is-done');
          if (label) { var old = label.textContent; label.textContent = 'Added'; setTimeout(function () { label.textContent = old; btn.classList.remove('is-done'); }, 2200); }
          var t = card && card.querySelector('.pr-card__title a, .pr-fslide__title a'); var im = card && card.querySelector('.pr-card__img, .pr-fslide__media img');
          showToast(t ? t.textContent : '', im ? (im.currentSrc || im.src) : '');
        })
        .catch(function () { btn.classList.remove('is-busy'); form.submit(); });
    });
  });
})();